__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "profile-webapp";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@nackle/biw-web-router", "2.0.10", () => (Promise.all([__webpack_require__.e(655), __webpack_require__.e(979), __webpack_require__.e(179)]).then(() => (() => (__webpack_require__(4655))))));
			register("@nackle/bridge", "3.0.51", () => (Promise.all([__webpack_require__.e(451), __webpack_require__.e(979), __webpack_require__.e(936)]).then(() => (() => (__webpack_require__(5451))))));
			register("@nackle/intl-tools", "1.4.85", () => (Promise.all([__webpack_require__.e(769), __webpack_require__.e(979)]).then(() => (() => (__webpack_require__(6769))))));
			register("@nackle/origami-icons", "1.7.28", () => (Promise.all([__webpack_require__.e(790), __webpack_require__.e(979)]).then(() => (() => (__webpack_require__(8790))))));
			register("@nackle/origami", "2.57.7", () => (Promise.all([__webpack_require__.e(317), __webpack_require__.e(979), __webpack_require__.e(113), __webpack_require__.e(571), __webpack_require__.e(70)]).then(() => (() => (__webpack_require__(317))))));
			register("@nackle/umbrella", "2.1.35", () => (Promise.all([__webpack_require__.e(294), __webpack_require__.e(571), __webpack_require__.e(696)]).then(() => (() => (__webpack_require__(9294))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(143), __webpack_require__.e(979)]).then(() => (() => (__webpack_require__(8143))))));
			register("react-redux", "9.3.0", () => (Promise.all([__webpack_require__.e(318), __webpack_require__.e(979)]).then(() => (() => (__webpack_require__(7318))))));
			register("react", "18.3.1", () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(758))))));
			register("redux", "5.0.1", () => (__webpack_require__.e(398).then(() => (() => (__webpack_require__(8398))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};